module.exports = __webpack_public_path__ + "static/EnmTX_BosRedeye_L_A_cl-3a24a9f301ebde435bdda231c38b4152.gif";